module.exports = __webpack_public_path__ + "img/project5_1.cd85cc29.jpg";